import { BranchCode } from 'api/risk';
import { documentsAPI } from 'services/swagger-api/documentsAPI';
import { ContractualizationSyncActions } from '../contexts/actions/types';

export const fetchSimulationDocuments = async (
  quoteId: string,
  branchCode: BranchCode,
  actions: ContractualizationSyncActions
): Promise<void> => {
  try {
    actions.setIsFetchingDocuments(true);
    actions.setError(null);

    const response = await documentsAPI.getSimulationDocumentsByQuoteID({
      quoteId
    });

    actions.setFetchedDocuments(branchCode, response.documents);
  } catch (error) {
    console.error('Erreur lors de la récupération des documents:', error);
    actions.setError(
      error instanceof Error
        ? error.message
        : 'Failed to fetch documents by strategy'
    );
  } finally {
    actions.setIsFetchingDocuments(false);
  }
};
